<div class="container-fluid pb-4">
  <div class="pb-4">
    <div class="pt-4 pb-2 heading-container">
      <h1 class="d-inline-block align-middle m-0" data-test-id="page-heading">
        {{ 'NOTIFICATION_PREFERENCES_TITLE' | translate }}
      </h1>
    </div>
    <label data-test-id="notification-preferences-page-tip">{{
      'NOTIFICATION_PREFERENCES_PAGE_TIP' | translate
    }}</label>
  </div>
  <div [formGroup]="form" *ngIf="initialFormValues">
    <div class="notification-context-preferences pt-1">
      <h3>
        {{ 'NOTIFICATION_PREFERENCES_CONNECTIONS_SECTION' | translate }}
      </h3>
      <span class="text-muted">{{ 'NOTIFICATION_PREFERENCES_CONNECTIONS_HINT' | translate }}</span>
      <div class="switches-box" formGroupName="connections">
        <div class="form-check form-switch">
          <label>
            <input
              id="connections-email-switch"
              type="checkbox"
              class="form-check-input"
              formControlName="emailsEnabled"
            />
            {{ 'NOTIFICATION_PREFERENCES_TYPE_EMAILS' | translate }}
          </label>
        </div>
        <div class="form-check form-switch">
          <label>
            <input
              id="connections-messaging-switch"
              type="checkbox"
              class="form-check-input"
              formControlName="messagingEnabled"
            />
            {{ 'NOTIFICATION_PREFERENCES_TYPE_MESSAGING' | translate }}
          </label>
        </div>
      </div>
    </div>
    <div class="notification-context-preferences">
      <h3>
        {{ 'NOTIFICATION_PREFERENCES_FILES_SECTION' | translate }}
      </h3>
      <span class="text-muted">{{ 'NOTIFICATION_PREFERENCES_FILES_HINT' | translate }}</span>
      <div class="switches-box" formGroupName="files">
        <div class="form-check form-switch">
          <label>
            <input id="files-email-switch" type="checkbox" class="form-check-input" formControlName="emailsEnabled" />
            {{ 'NOTIFICATION_PREFERENCES_TYPE_EMAILS' | translate }}
          </label>
        </div>
        <div class="form-check form-switch">
          <label>
            <input
              id="files-messaging-switch"
              type="checkbox"
              class="form-check-input"
              formControlName="messagingEnabled"
            />
            {{ 'NOTIFICATION_PREFERENCES_TYPE_MESSAGING' | translate }}
          </label>
        </div>
      </div>
    </div>
    <div class="notification-context-preferences">
      <h3>
        {{ 'NOTIFICATION_PREFERENCES_COMMUNITIES_AND_PROJECTS_SECTION' | translate }}
      </h3>
      <span class="text-muted">{{ 'NOTIFICATION_PREFERENCES_COMMUNITIES_AND_PROJECTS_HINT' | translate }}</span>
      <div class="switches-box" formGroupName="social_group">
        <div class="form-check form-switch">
          <label>
            <input
              id="social-group-email-switch"
              type="checkbox"
              class="form-check-input"
              formControlName="emailsEnabled"
            />
            {{ 'NOTIFICATION_PREFERENCES_TYPE_EMAILS' | translate }}
          </label>
        </div>
        <div class="form-check form-switch">
          <label>
            <input
              id="social-group-messaging-switch"
              type="checkbox"
              class="form-check-input"
              formControlName="messagingEnabled"
            />
            {{ 'NOTIFICATION_PREFERENCES_TYPE_MESSAGING' | translate }}
          </label>
        </div>
      </div>
    </div>
    <div class="notification-context-preferences">
      <h3>
        {{ 'NOTIFICATION_PREFERENCES_COMMENTS_SECTION' | translate }}
      </h3>
      <span class="text-muted">{{ 'NOTIFICATION_PREFERENCES_COMMENTS_HINT' | translate }}</span>
      <div class="switches-box" formGroupName="comments">
        <div class="form-check form-switch">
          <label>
            <input
              id="comments-email-switch"
              type="checkbox"
              class="form-check-input"
              formControlName="emailsEnabled"
            />
            {{ 'NOTIFICATION_PREFERENCES_TYPE_EMAILS' | translate }}
          </label>
        </div>
        <div class="form-check form-switch">
          <label>
            <input
              id="comments-messaging-switch"
              type="checkbox"
              class="form-check-input"
              formControlName="messagingEnabled"
            />
            {{ 'NOTIFICATION_PREFERENCES_TYPE_MESSAGING' | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="change-all-preferences">
    <div class="form-check form-switch">
      <label>
        <input
          id="update-all-preferences-switch"
          [attr.data-test-id]="'update-all-preferences-switch'"
          type="checkbox"
          class="form-check-input"
          [(ngModel)]="allPreferencesSwitchValue"
          (change)="switchAllPreferences($event.target.checked)"
        />
        {{ 'NOTIFICATION_PREFERENCES_ALL_PREFERENCES_SWITCH' | translate }}
      </label>
    </div>
  </div>
  <div class="d-inline-flex gap-2">
    <button
      appLongOperation
      class="btn btn-primary text-white send-code"
      type="button"
      data-test-id="save-notification-preferences-btn"
      [disabled]="!isFormChanged"
      (click)="updateNotificationPreferences()"
    >
      {{ 'BTN_SAVE_HINT' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-secondary"
      data-test-id="discard-notification-preferences-changes-btn"
      [disabled]="!isFormChanged"
      (click)="discardChanges()"
    >
      {{ 'NOTIFICATION_PREFERENCES_DISCARD_CHANGES' | translate }}
    </button>
  </div>
</div>
